<template>
  <div>
    <div class="container">
      <div class="row mt-5">
        <div class="col-12 mx-auto mb-3">
          <h1 class="text-center  " :class="'text-primary'">Forgot my password</h1>
        </div>
        <div class="col-5 mx-auto">
          <div class="card mb-3">
            <div class="card-body">
              <form>
                <div class="form-group">
                  <label for="email">Email address</label>
                  <input type="email" class="form-control" id="email" v-model="email" placeholder="Enter your email">
                </div>
                <button type="submit" class="btn float-right" :class="'btn-dark'" @click.prevent="forgot">Send reset link</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'forgot',
  methods: {
    forgot() {
      window.firebase.auth().sendPasswordResetEmail(this.email)
        .then(() => this.$toasted.show('A password reset email has been sent.'))
        .catch(err => this.$toasted.show(err.message));
    },
  },
  data() {
    return {
      email: '',
    };
  },
};
</script>
